<template>
  <header class="page-title-bar">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">
          <router-link to="/">
            <em class="breadcrumb-icon fa fa-angle-left mr-2"></em>Home
          </router-link>
        </li>
      </ol>
    </nav>
    <div class="d-md-flex align-items-md-start">
      <h1 class="page-title mr-sm-auto"> {{ title }} </h1>
      <div class="btn-toolbar btn-dtable"></div><!-- /.btn-toolbar -->
    </div>
  </header>
</template>

<script>
export default {
  name: "Breadcrumb",
  props:{
    title:{
      type:String
    }
  }
}
</script>